import {useEffect, useCallback, useState} from "react";

import useInterval from "../generic/hooks/use-interval/use-interval";
import {determineLanguage} from "../utils/cookie-language-helper";

window.digitalData = window.digitalData || [];
window.digitalDataEvents = {
  pageView: "Page View",
  productView: "Product View",
  addToCart: "Add to Cart",
  removeFromCart: "Remove from Cart",
  checkout: "Checkout",
  purchase: "Purchase",
  search: "Search",
  component: {
    click: "Component Click",
    share: "Share",
    formStart: "Form Start",
    formError: "Form Error",
    formSubmit: "Form Submit",
    download: "Download",
    checklistUpdated: "Checklist Updated"
  },
  authenticate: "Authenticate"
};

const useAnalyticsScript = ({configuration, navigation:propsNavigation}) => {

  const [loaded, setLoaded] = useState(false);
  const [eventObject, setEventObject] = useState();
  const [navigation,setNavigation] = useState(propsNavigation);
  useEffect(() => {
    setNavigation(propsNavigation)
  },[propsNavigation]);

  const loadCheckTrigger = useCallback(() => {
    //window._satellite is a global variable their analytics sets up when their script runs.
    if (window._satellite) {
      setLoaded(true);
    }
  },[]);

  const {stop:stopLoadCheck} = useInterval({milliseconds:100, onTrigger: loadCheckTrigger, autoStart:true});

  useEffect(() => {
    if (loaded) {
      stopLoadCheck();
    }
  },[loaded, stopLoadCheck]);

  useEffect(() => {
    const lane = configuration?.analyticsLane;
    const script = document.createElement('script');
    script.async = true;
    if (lane) {
      script.src = lane === "prod" ? "//assets.adobedtm.com/05064fe6cab0/b9d37f296ace/launch-fe44d8adbb98.min.js" :
        "//assets.adobedtm.com/05064fe6cab0/b9d37f296ace/launch-da2183d7ff8b-development.min.js"
    }
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    }

  }, [configuration?.analyticsLane])

  const isolatedAnalyticsPageEvent = useCallback((pageName, navigation) => {
    //change any names or any of that before we go live with this to prod. Commenting out so we can just turn it back on right after our release
    //and do the testing with them when they get a chance.
    const {area = {}, region = {}, coordinator = {}, program = {}, year = {}, term = {}} = navigation ?? {};
    //first run can get us here before our navigation has loaded and we should get a later analytics event
    //with our accurate load in that case.
    if (!area) {
      return;
    }
    const crumbs = {
      area: area?.name,
      region: region?.name ?? "na",
      coordinator: coordinator?.name ?? "na",
      program: program?.name,
      year: year?.name ?? "na",
      term: term?.name ?? "na"
    }

    const language = determineLanguage(true);//three character language code needed

    setEventObject({
      event:window.digitalDataEvents.pageView,
      page: {
        info: {
          name: pageName, //String - friendly name for the current page, usually based on the URL
          breadcrumbs:[crumbs.area, crumbs.region, crumbs.coordinator,crumbs.program, crumbs.year, crumbs.term],
          language,
          siteName: "Wise2"   // String - friendly unique name that identifies the current site, this will be provided in a Jira ticket
        }
      }
    })
  },[])

  const analyticsPageEvent = useCallback((pageName) => {
    isolatedAnalyticsPageEvent(pageName,navigation);
  },[navigation, isolatedAnalyticsPageEvent]);

  useEffect(() => {
    if (loaded && eventObject) {
      window.digitalData.push(eventObject);
    }
  },[loaded,eventObject]);

  return {
    analyticsPageEvent,
    isolatedAnalyticsPageEvent
  }
}

export default useAnalyticsScript;